<template>
  <div class="orderList">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        销售订单列表
        <div class="rutun" @click="geting()">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;"  class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">订单编号:</div>
          </el-col>
          <el-col :span="8">
            <el-input v-model="orderCode" clearable size="small" placeholder="订单编号"></el-input>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <!-- <div class="center_list_head_rig" @click="dialogFormVisible1 = true">添加客户</div> -->
        </div>
        <div class="center_list_center"></div>
      </div>

      <el-table v-show="group != 7" :data="tableData" border style="width: 100%">
        <el-table-column label="订单编号" width="180">
          <template slot-scope="scope">
            <router-link target="_blank" :to="'/admin/d_viewOrde/'+scope.row.id+'/1'">
              <el-link type="primary">{{scope.row.orderCode}}</el-link>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="product_list" label="订单商品" width="120"></el-table-column>
        <el-table-column prop="pay_money" label="订单金额(元)" width="110"></el-table-column>
        <el-table-column prop="create_time" label="订货时间" width="100"></el-table-column>
        <el-table-column prop="remark_name" label="备注名称" width="100"></el-table-column>
        <el-table-column prop="address" label="收货信息"></el-table-column>
        <el-table-column prop="status" width="80" label="状态"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div>
              <el-link
                type="primary"
                @click="showSellRemark = true,remarkOrderCode = scope.row.orderCode"
              >备注订单</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-show="group == 7" :data="tableData" border style="width: 100%">
        <el-table-column label="订单编号" width="180">
          <template slot-scope="scope">
            <router-link target="_blank" :to="'/admin/d_viewOrde/'+scope.row.id+'/1'">
              <el-link type="primary">{{scope.row.orderCode}}</el-link>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="product_list" label="订单商品" width="120"></el-table-column>
        <el-table-column prop="pay_money" label="订单金额(元)" width="110"></el-table-column>
        <el-table-column prop="create_time" label="订货时间" width="100"></el-table-column>
        <el-table-column prop="remark_name" label="备注名称" width="100"></el-table-column>
        <el-table-column prop="address" label="收货信息"></el-table-column>
        <el-table-column prop="status" width="80" label="状态"></el-table-column>
        <el-table-column prop="real_name" width="80" label="负责人"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div>
              <el-link
                type="primary"
                @click="showSellRemark = true,remarkOrderCode = scope.row.orderCode"
              >备注订单</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager1">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          @current-change="setPage"
        ></el-pagination>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 后台订单备注 -->
    <el-dialog title="订单销售备注" :visible.sync="showSellRemark" width="33%">
      <el-form>
        <el-form-item>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入备注信息"
            v-model="sell_remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSellRemark = false">取 消</el-button>
        <el-button type="primary" @click="showSellRemark = false,sellRemarkOrder()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'list',
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      serve: this.$store.state.serve,
      token: this.$cookies.get('token'),
      username: this.$cookies.get('username'),
      page: null,
      total: 0,
      tableData: [],
      bind_mobile: '',
      orderCode: '',
      showSellRemark: false,
      remarkOrderCode: '',
      sell_remark: '',
      group:''
    }
  },
  created() {
    this.$store.state.topActiveId = 9
    this.$store.state.leftTitle = '客户订单'
    this.geting()
  },
  watch: {},
  methods: {
    alert_success(message) {
      this.$message({
        type: 'success',
        message: message,
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        type: 'error',
        message: message,
        offset: 200
      })
    },
    sellRemarkOrder() {
      var where = {
        username: this.username,
        token: this.token,
        remark: this.sell_remark,
        orderCode: this.remarkOrderCode
      }
      this.axios
        .get(this.serve + '/admin/sellRemarkOrder', { params: where })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.showSellRemark = false
            this.alert_success('备注成功!')
            this.sell_remark = ''
          }else if(data.code == '403'){
            this.$message.error(data.msg);
          } else {
            this.showSellRemark = false
            this.alert_error('备注失败!')
          }
        })
    },
    setPage(v) {
      //分页
      this.page = v
      this.geting(v)
      this.selectAll = false
    },
    geting(page) {
      //请求数据
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var that = this
      var where = {
        username: this.username,
        token: this.token,
        page: page ? page : this.page
      }
      where.orderCode = this.orderCode
      this.axios
        .get(this.serve + '/admin/sell_orderList', {
          params: where
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.tableData = data.data.results
            this.total = data.data.total
            this.page = data.data.page
            this.group = data.data.group
          } else {
            if(data.msg == "无权访问"){
              this.role = false
            }
            this.tableData = []
          }
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss">
.orderList {
    .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top:19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>